import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap5';

import Modal from 'components/new_ui/Modal/Modal';
import { useContext } from 'components/Managers/Billing/Context';
import getPaymentMethodLink from 'components/Common/Billing/utils/getPaymentMethodLink';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Form from './Form';

export default function ChooseCreatePaymentMethod({ show, onHide }) {
  const { actions, dispatch } = useContext();

  const [showBillingMethod, setShowBillingMethod] = useState(false);

  const [loadingDefaultBillingInformation, setLoadingDefaultBillingInformation] = useState(false);
  const [defaultBillingInformation, setDefaultBillingInformation] = useState(null);

  const [loadingSetPaymentLink, setLoadingPaymentLink] = useState(false);

  const onShowBillingMethod = () => {
    setLoadingDefaultBillingInformation(true);
    actions.prepareBillingInformation((data) => {
      setDefaultBillingInformation(data);
      setLoadingDefaultBillingInformation(false);
      onHide();
      setShowBillingMethod(true);
    });
  };

  const onSetPaymentMethod = () => {
    setLoadingPaymentLink(true);
    getPaymentMethodLink({
      paymentInformationId: null,
    }).then((res) => {
      setLoadingPaymentLink(false);
      actions.addOrUpdatePaymentMethod(dispatch, res.payment_information);
      document.location.href = res.link;
    });
  };

  return (
    <>
      <Modal size="lg" show={show}>
        <>
          <div className="text-center">
            <h2>Add Payment Method</h2>
            <small>Secure & Swift: Link Your Payment Method in Just a Few Clicks!</small>
          </div>
          <Row className="mt-3">
            <Col md={6} className="mt-2">
              Link a credit card or bank account to your
              profile to setup automatic payment.
            </Col>
            <Col md={6} className="text-center text-md-end mt-2">
              <Button
                style={{ width: '300px' }}
                onClick={onSetPaymentMethod}
                disabled={loadingSetPaymentLink}
              >
                {loadingSetPaymentLink && <LoadingPlaceholder placement="inline" text=" " />}
                Add Payment Information
              </Button>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={6} className="mt-2">
              Enter a new billing address to receive invoice
              emails and pay manually.
            </Col>
            <Col md={6} className="text-center text-md-end mt-2">
              <Button
                style={{ width: '300px' }}
                disabled={loadingDefaultBillingInformation}
                onClick={onShowBillingMethod}
              >
                {loadingDefaultBillingInformation && <LoadingPlaceholder placement="inline" text=" " />}
                Add New Billing Address
              </Button>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="text-center text-md-end">
              <Button
                variant="outline-primary"
                className=""
                onClick={onHide}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </>
      </Modal>

      {defaultBillingInformation !== null && (
      <Form
        show={showBillingMethod}
        onHide={() => setShowBillingMethod(false)}
        initValue={defaultBillingInformation}
      />
      )}
    </>
  );
}

ChooseCreatePaymentMethod.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
